<template>
  <ApplicationFooterSection>
    <ApplicationFooterSectionButton to="/contact">
      Contact
    </ApplicationFooterSectionButton>
    <p class="mb-2 text-pretty leading-6 lg:mb-4 ">
      Heb je een vraag of wil je iets kwijt? Neem dan contact met ons op via het contactformulier.
    </p>
  </ApplicationFooterSection>
</template>
